export function calcAutoCloseDelay(
  autoClose: boolean | undefined,
  undoable: boolean | undefined
): number {
  if (!autoClose) {
    return -1;
  }

  return undoable ? 5000 : 2000;
}
